import * as React from "react";
import { fakeCustomers } from "./config";
import { ICustomer, TransitionTypeEnum } from "./Reviews.types";
import RightArrow from "../../icons/right-arrow";
import ToggleDot from "../../components/toggle-dot/ToggleDot";

const Reviews = () => {
  const [customers, setCustomers] = React.useState<ICustomer[]>(fakeCustomers);
  const [currentCustomerIdx, setCurrentCustomerIdx] = React.useState<number>(0);
  const [transitionState, setTransitionState] =
    React.useState<TransitionTypeEnum>(TransitionTypeEnum.FADE_IN);

  const handleChangeCustomer = (newCustomerIdx: number) => {
    if (newCustomerIdx === currentCustomerIdx) return;
    setTransitionState((prev) =>
      prev === TransitionTypeEnum.FADE_IN
        ? TransitionTypeEnum.FADE_OUT
        : TransitionTypeEnum.FADE_IN
    );

    setTimeout(() => {
      setCurrentCustomerIdx(
        newCustomerIdx > customers.length - 1 ? 0 : newCustomerIdx
      );

      setTransitionState((prev) =>
        prev === TransitionTypeEnum.FADE_IN
          ? TransitionTypeEnum.FADE_OUT
          : TransitionTypeEnum.FADE_IN
      );
    }, 500);
  };

  return (
    <div className="flex flex-col gap-y-8 mt-8">
      <p className={`${transitionState}`}>
        {customers[currentCustomerIdx].opinion}
      </p>
      <div className={`flex flex-col gap-y-2 ${transitionState}`}>
        <span className="font-bold">
          {customers[currentCustomerIdx].customerName}
        </span>
        <span className="text-[11px]">
          {customers[currentCustomerIdx].companyName}
        </span>
      </div>
      <div className="flex items-center gap-x-4">
        <ToggleDot
          isActive={currentCustomerIdx === 0}
          handleSelect={() => handleChangeCustomer(0)}
        />{" "}
        <ToggleDot
          isActive={currentCustomerIdx === 1}
          handleSelect={() => handleChangeCustomer(1)}
        />{" "}
        <ToggleDot
          isActive={currentCustomerIdx === 2}
          handleSelect={() => handleChangeCustomer(2)}
        />
        <strong className="cursor-pointer">
          <RightArrow
            onClick={() => handleChangeCustomer(currentCustomerIdx + 1)}
          />
        </strong>
      </div>
    </div>
  );
};

export default Reviews;
